import { configWithUserToken } from "./config";

export const checkFavorite = (restourantId: string) => {
  return configWithUserToken.get<boolean>(`Favorite/check/${restourantId}`);
};

export const toggleFavorite = (restourantId: string) => {
  return configWithUserToken.post(`Favorite/${restourantId}`);
};
